import { AddEdgeAdjustmentStateEnum, EdgeAdjustmentWithoutID } from "../Components/EdgeTools/AddEdgeAdjustment";
import { ICADModel, ICADOperationLibraryItem, ICADOperationEditor, ICADOperation } from "../interfaces";
import { CADActionTypes } from "./CADStateReducer";

export class CADActions {

    #dispatcher: React.Dispatch<CADActionTypes>;
    #debounceTimer: NodeJS.Timeout | null = null;

    constructor(dispatcher: React.Dispatch<CADActionTypes>) {
        this.#dispatcher = dispatcher;
    }

    setModel(model: ICADModel, resetCurrentLayer: boolean) {
        this.#dispatcher({ type: "SET_MODEL", model, resetCurrentLayer });
    }

    setHoveredOperation(uniqueID: number | null) {
        this.#dispatcher({ type: "SET_HOVERED_OPERATION", uniqueID });
    }

    setSelectedOperation(operation: ICADOperation | null) {

        const uniqueID = operation ? operation.uniqueID : null;

        this.#dispatcher({ type: "SET_SELECTED_OPERATION", uniqueID });

        if (operation) {
            //Make sure we are viewing the tab that corresponds to the selected operation

            this.setCurrentTab(operation.operationType.toString());
        }

    }

    setUnitSetID(unitSetID: number) {
        this.#dispatcher({ type: "SET_UNIT_SET_ID", unitSetID });
    }

    addOperationLibrary(libraryKey: string, libraryItems: ICADOperationLibraryItem[]) {
        this.#dispatcher({ type: "ADD_OPERATION_LIBRARY", libraryKey, libraryItems });
    }

    setOperationEditor(editor: ICADOperationEditor | null) {
        this.#clearDebounceTimer();
        this.#dispatcher({ type: "SET_OP_EDITOR", editor });
    }

    setOperationEditorLoading() {
        //Only lock down fields if the API response takes more than 250ms
        this.#clearDebounceTimer();
        this.#debounceTimer = setTimeout(() => {
            this.#dispatcher({ type: "SET_OP_EDITOR_LOADING", loading: true });
        }, 250);
    }

    setActiveEdgeAdjustment(edgeAdjustment: EdgeAdjustmentWithoutID | null, edgeToolState: AddEdgeAdjustmentStateEnum | null = null) {
        this.#dispatcher({ type: "SET_ACTIVE_EDGE_ADJUSTMENT", edgeAdjustment });

        if (edgeToolState !== null) {
            this.#dispatcher({ type: "SET_EDGE_TOOL_STATE", edgeToolState });
        }

        if (edgeAdjustment) {
            //Make sure we are viewing the tab that corresponds to the selected operation

            this.setCurrentTab("EdgeAdjustments");
        }

    }

    setCurrentTab(tab: string) {
        this.#dispatcher({ type: "SET_CURRENT_TAB", tab });
    }

    setCurrentLayer(layer: string) {
        this.#dispatcher({ type: "SET_CURRENT_LAYER", layer });
    }

    clearUIState() {
        this.setOperationEditor(null);
        this.setHoveredOperation(null);
        this.setSelectedOperation(null);
        this.setActiveEdgeAdjustment(null, AddEdgeAdjustmentStateEnum.None);
    }

    #clearDebounceTimer() {
        if (this.#debounceTimer) {
            clearTimeout(this.#debounceTimer);
            this.#debounceTimer = null;
        }
    }

};
